import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { PendingPayment } from '../../../shared/entities/PendingPayment';
import { PaymentTypes } from '../../../shared/entities/PaymentTypes';
import { dbErrorEntry } from '../../../shared/entities/dbErrorEntry';
import { ApnUtilitiesService } from '../data/apn-utilities.service';


const GET_PAYMENT_TYPES_FOR_LOT_NUMBER = 'Invoice/GetPaymentTypesForLotNumber';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  })
};

@Injectable()
  export class ValidationService {
    pendingPayments: PendingPayment[];
    paymentTypes: PaymentTypes[];
    readonly restServerEndPoint: string;

    constructor(    private http: HttpClient, 
                    private apnUtilityService: ApnUtilitiesService ) 
    {
        this.restServerEndPoint = environment.production === true ? environment.RestServer : environment.RestServer;  
    }

    validatePendingPaymentList(pendingPayments: PendingPayment[]): boolean{
        let paymentListIsValid: boolean = true;


        return paymentListIsValid;
    }

    
    //Validation for pending payment list

    //Get paymentCode List From Database

    //Loop through each pending payment
        //Does payment code/description match up with payment code list
        //If not, lookup payment code from payment description and update pending payment list

    // return valid pending payment list


    //Questions
    //1. If we encounter an error, should we ask user to verify that each payment is correct that was suspect


    getRevenueAdjustmentReasonsList(lotNumber: string){
        this.getPaymentTypesForLotNumber(lotNumber).subscribe(
          resp => this.paymentTypes = resp,
          (err:any) => {
            let errorLogEntry: dbErrorEntry = new dbErrorEntry();
    
            errorLogEntry.Location = 'Err: validation.services.ts::getRevenueAdjustmentReasonsList().';
            errorLogEntry.errorMessage = JSON.stringify(err);
            this.apnUtilityService.logErrorToDB(errorLogEntry);
          },
          () => {
           
          }
        )
    }

    getPaymentTypesForLotNumber(lotNumber: string): Observable<PaymentTypes[]> {
  
        let queryString: string = `LotNumber=${lotNumber}`;
  
        var endpoint = this.restServerEndPoint +  GET_PAYMENT_TYPES_FOR_LOT_NUMBER + `?${queryString}`;
      
        return this.http.get<PaymentTypes[]>(endpoint);
        
    }
    

}